


























































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AccountModule from '@/store/modules/Account';
import GeneralModule from '@/store/modules/General';
import BalanceModule from '@/store/modules/Balance';
import ProfileModule from '@/store/modules/Profile';
import AuthModule from '@/store/modules/Auth';
import CreateAccountData from '@/data/CreateAccount';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component
export default class AddAgentView extends Mixins(ErrorHandleMixin) {
  AccountInstance = getModule(AccountModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  BalanceInstance = getModule(BalanceModule, this.$store);

  ProfileInstance = getModule(ProfileModule, this.$store);

  mainKey = 0;

  UserData: any = { ...CreateAccountData.initialUserData() };

  async created() {
    this.generateUsername();
  }

  async generateUsername() {
    this.UserData.role = 'MEMBER';
    const { status, data } = await this.AccountInstance.GenerateUser({
      role: this.UserData.role,
    });
    if (status.code) {
      this.checkError(status);
    } else {
      this.UserData.username = data.username;
    }
  }

  async onSubmit() {
    this.UserData.pt.general = this.AuthInstance.user.pt.general;
    this.UserData.type = this.AuthInstance.user.type;
    this.GeneralInstance.toggleLoading(true);
    const {
      status: {
        code, message,
      },
      data,
    } = await this.AccountInstance.CreateAccount(this.UserData);
    if (code === 0) {
      await this.BalanceInstance.Refill({
        userId: data._id,
        type: 'TRANSFER',
        amount: this.UserData.balance,
        username: data.username,
      });
      this.ProfileInstance.GetBalance();
      this.mainKey += 1;
    }
    this.GeneralInstance.toggleLoading(false);
    this.GeneralInstance.ShowAlert({
      isAlert: true,
      alertMsg: message,
      alertColor: code === 0 ? 'success' : 'danger',
    });
    this.UserData = { ...CreateAccountData.initialUserData() };
    this.generateUsername();
  }
}
